import { IPublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import "@progress/kendo-theme-fluent/scss/all.scss";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { AppConfig, load } from "./config";
import "./index.scss";
import { initialize } from "./msal";
import reportWebVitals from "./reportWebVitals";

async function bootstrap() {
  const config = await load();
  const instance = await initialize(config.auth);

  render(config, instance);
}

function render(config: AppConfig, instance: IPublicClientApplication) {
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <MsalProvider instance={instance}>
        <App config={config} />
      </MsalProvider>
    </React.StrictMode>
  );

  reportWebVitals();
}

bootstrap().catch((error) => console.error(error));
